module.exports = __webpack_public_path__ + "img/icon_service_satisfaction_questionnaire.39b95cf0.svg";